module.exports = __webpack_public_path__ + "media/fonts/Aleo-Bold-2b1167f1f883607cbf52e9bf468cae8a.ttf";